import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * App-wide notifier for supervisor mutations. Each view keeps its own component-scoped
 * `SupervisorsStore`, so a create/update/delete in one view (e.g. the supervisor editor) can't be
 * seen by another (e.g. the sidebar's "My Supervisors" list). Mutation flows call `notifyChanged()`
 * and interested views listen on `changed$` to reload.
 */
@Injectable({ providedIn: 'root' })
export class SupervisorsRefreshService {
  readonly #changed = new Subject<void>();

  /** Emits whenever a supervisor is created, updated, or deleted. */
  readonly changed$: Observable<void> = this.#changed.asObservable();

  notifyChanged(): void {
    this.#changed.next();
  }
}
